import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import Checkbox from 'Common/components/Form/Fields/Checkbox';
import FormField from 'Common/components/Form/FormField';
import Button from 'Common/components/Button';
import { orderBy } from 'lodash';

const ButtonsWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin-bottom: 20px;

    > button {
        width: auto;
        min-width: 200px;
        margin: 10px;
    }
`;

const ButtonWrapper = styled.div`
    > button {
        width: auto;
    }
`;

const Title = styled.div`
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 21px;

    @media screen and (min-width: 940px) {
        font-size: 18px;
        line-height: 27px;
    }
`;

const CheckboxesWrapper = styled.div`
    margin-bottom: 20px;

    @media screen and (min-width: 520px) {
        display: flex;
        flex-wrap: wrap;
        max-width: 420px;
    }
`;

const StyledFormField = styled(FormField)`
    @media screen and (min-width: 520px) {
        flex: 0 0 auto;
        width: calc(50% - 20px);
        margin-right: 40px;

        &:nth-child(2n) {
            margin-right: 0;
        }
    }
`;

const GroupAssignmentEmployeeChecklist = ({
    employees,
    confirmButtonText,
    onConfirm,
}) => {
    const [isConfirming, setIsConfirming] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);

    const handleCheckboxChange = (id, isChecked) => {
        setSelectedIds(prevSelectedIds => {
            const newSelectedIds = [...prevSelectedIds];

            if (isChecked && !prevSelectedIds.includes(id)) {
                newSelectedIds.push(id);
            } else if (!isChecked && prevSelectedIds.includes(id)) {
                const index = newSelectedIds.indexOf(id);

                newSelectedIds.splice(index, 1);
            }

            return newSelectedIds;
        });
    };

    const handleButtonClick = async () => {
        setIsConfirming(true);

        await onConfirm(selectedIds);

        setIsConfirming(false);
    };

    const handleSelectAll = () => {
        setSelectedIds(employees.map(employee => employee.id));
    };

    const handleDeselectAll = () => {
        setSelectedIds([]);
    };

    return (
        <>
            <Title>Bestätigen Sie hier die Anwesenheit der Mitarbeiter</Title>
            <ButtonsWrapper>
                <Button
                    outline
                    type="button"
                    onClick={handleSelectAll}
                    disabled={selectedIds.length === employees.length}
                >
                    Wählen Sie Alle
                </Button>
                <Button
                    outline
                    type="button"
                    onClick={handleDeselectAll}
                    disabled={selectedIds.length === 0}
                >
                    Alle abwählen
                </Button>
            </ButtonsWrapper>
            <CheckboxesWrapper>
                {orderBy(
                    employees,
                    ['lastName', 'firstName'],
                    ['asc', 'asc'],
                ).map(employee => (
                    <StyledFormField key={employee.id}>
                        <Checkbox
                            id={`employee_${employee.id}`}
                            name="employee[]"
                            label={`${employee.lastName}, ${employee.firstName}`}
                            checked={selectedIds.includes(employee.id)}
                            onChange={e =>
                                handleCheckboxChange(
                                    employee.id,
                                    e.target.checked,
                                )
                            }
                        />
                    </StyledFormField>
                ))}
            </CheckboxesWrapper>
            <ButtonWrapper>
                <Button
                    type="button"
                    isLoading={isConfirming}
                    disabled={isConfirming || selectedIds.length === 0}
                    onClick={handleButtonClick}
                >
                    {confirmButtonText}
                </Button>
            </ButtonWrapper>
        </>
    );
};

GroupAssignmentEmployeeChecklist.propTypes = {
    employees: PropTypes.array.isRequired,
    onConfirm: PropTypes.func.isRequired,
    confirmButtonText: PropTypes.string.isRequired,
};

export default GroupAssignmentEmployeeChecklist;
